<p-card class="p-card container">
  <h3 class="flex justify-content-between"
    >Notes
    <i (click)="openDialog()" class="pi pi-window-maximize cursor-pointer"></i>
  </h3>

  <ng-container *ngTemplateOutlet="notesTemplate; context: {buttonDisabled: isDialogVisible}"></ng-container>
</p-card>

<p-dialog
  class="dialog"
  focusOnShow="false"
  appendTo="body"
  header="Notes"
  (onHide)="form.reset()"
  [(visible)]="isDialogVisible"
  [modal]="true"
  [dismissableMask]="true"
  [style]="{width: '75vw', 'box-shadow': '0 2px 4px 1000px rgba(0, 0, 0, 0.15)'}">
  <ng-container *ngTemplateOutlet="notesTemplate; context: {buttonDisabled: false}"></ng-container>
</p-dialog>

<ng-template #notesTemplate let-buttonDisabled="buttonDisabled">
  @if (_notes.length > 0) {
    <div class="layout__inner-card">
      @for (note of _notes; track note; let last = $last) {
        @if (note.title) {
          <h6 class="mb-0 font-semibold line-height-2">{{ note.title }}</h6>
        }
        <p class="pt-1 mb-0 overflow-x-auto" [innerHTML]="note.text | emMarkdown"></p>
        @if (note.agentId) {
          <div class="text-right text-sm text-600 pt-2" i18n>
            Par {{ note.agentName }}, le {{ note.createdAt | date: dateFormat }}
          </div>
        }
        @if (!note.agentId) {
          <div class="text-right text-sm text-600 pt-2" i18n>
            Le {{ note.createdAt | date: dateFormat }}
          </div>
        }
        @if (!last) {
          <p-divider></p-divider>
        }
      }
    </div>
  } @else {
    <i class="text-600" i18n>Aucune note au dossier</i>
  }

  <div class="flex mt-3 flex-column gap-3">
    <p class="my-0" i18n>Écrire une nouvelle note</p>

    <p-editor
      [formControl]="form"
      [maxlength]="15000"
      [style]="{'min-height': '100px'}"
      (onInit)="onEditorInit($event)"
      placeholder="Aa...">
      <ng-template pTemplate="header">
        <span class="ql-formats">
          <button type="button" class="ql-bold" aria-label="Bold"></button>
          <button type="button" class="ql-italic" aria-label="Italic"></button>
          <button type="button" class="ql-underline" aria-label="Underline"></button>
          <button type="button" class="ql-background" aria-label="Background" value="#f8e71c"></button>
          <button type="button" class="ql-list" value="bullet" aria-label="Unordered List"></button>
          <button type="button" class="ql-list" value="ordered" aria-label="Ordered List"></button>
        </span>
      </ng-template>
    </p-editor>

    <p-button
      (onClick)="submitNote()"
      [loading]="isLoading"
      [disabled]="form.invalid || buttonDisabled"
      icon="pi pi-check"
      i18n-label
      label="Enregistrer la note"></p-button>
  </div>
</ng-template>
